<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      title="选择物料"
      width="1200px"
      top="8vh">
    <table-select
        ref="tableSelect"
        :filter="filter"
        :columns="columns"
        module="basic"
        url="materials"
        @select="selectMaterial"
        @reset="resetHandle">
      <template slot="adSearch">
        <el-form ref="form" :inline="true" :model="filter" @submit.native.prevent>
          <el-form-item label="关键字" prop="keyWords">
            <el-input v-model.trim="filter.keyWords" placeholder="请输入关键字查询" clearable/>
          </el-form-item>
          <!-- <el-form-item label="业务类别" prop="businessTypeName">
            <el-select v-model="filter.businessTypeName" placeholder="请选择业务类别" clearable>
              <el-option label="运控产品" value="运控产品" />
              <el-option label="之山产品" value="之山产品" />
              <el-option label="之山专机" value="之山专机" />
            </el-select>
          </el-form-item> -->
        </el-form>
      </template>
    </table-select>
  </el-dialog>
</template>

<script>
  import TableSelect from "@/components/TableSelect.vue";

  export default {
    components: { TableSelect },
    data() {
      return {
        dialogVisible: false,
        filter: {
          keyWords: "",
          statusName: "",
          // businessTypeName: "",
        },
        columns: [
          // {
          //   title: "业务类别",
          //   key: "businessTypeName",
          //   align: "center",
          //   width: 100,
          // },
          {
            title: "物料编号",
            key: "materialNO",
            width: 160,
          },
          {
            title: "物料名称",
            key: "materialName",
            minWidth: 400,
          },
          {
            title: "物料规格",
            key: "specification",
            minWidth: 260,
          },
          {
            title: "物料类型",
            key: "materialTypeName",
            width: 140,
          },
          {
            title: "状态",
            key: "statusName",
            width: 80,
            align: "center",
          },
          {
            title: "操作",
            slot: "action",
            width: 80,
            align: "center",
            fixed: "right",
          },
        ],
      };
    },
    methods: {
      open(statusName) {
        this.dialogVisible = true;
        this.temp = statusName;
        this.$nextTick(() => {
          this.$refs.form.resetFields();
          this.filter.statusName = statusName;
          this.$refs.tableSelect.loadData();
        });
      },

      selectMaterial(row) {
        this.dialogVisible = false;
        this.$emit("select", row);
      },

      resetHandle(filter) {
        this.filter = filter;
        this.$nextTick(() => {
          this.filter.statusName = this.temp;
          this.$refs.tableSelect.loadData();
        });
      },
    },
  };
</script>
